module.exports = __webpack_public_path__ + "media/images/smart_phone/menus/201707/top_images/2-2-00b1ace5d00eb4b88ea9dccafce1f8b7.png";